import { ValueObjectDTO } from '@core/dto/value-object.dto';
import { Model, Serializer } from '@junte/serialize-ts';

import { BaseModel } from './base-model';

export class ValueObjectSerializer implements Serializer<ValueObject> {
  public deserialize(dto: ValueObjectDTO | any): ValueObject {
    // Handle case where backend returns 'code' instead of 'codename'
    const mapped = dto.code ? { ...dto, codename: dto.code } : dto;
    return ValueObject.create(mapped);
  }

  public serialize(model: ValueObject): ValueObjectDTO {
    return model;
  }
}

@Model(new ValueObjectSerializer())
export class ValueObject extends BaseModel {
  public codename: string;
  public name: string;

  public static create(data: Partial<ValueObject>): ValueObject {
    return Object.assign(new ValueObject(), data);
  }
}
